import module from 'finanzas/module.js'

const schema = {
  lote_id: 'number',
  id_cuenta: 'number',
  id_empresa: 'number',
  id_movimiento: 'id_movimiento',
  fecha: 'date',
  importe: 'number',
}

class FinancesCargarMovimientosBancariosHistorialDetalladoService {
  constructor ($http) {
    this.$http = $http
  }

  get (loteId) {
    return this.$http.get('/api/finanzas/carga_movimientos/historial/detallado', {
      params: {lote_id: loteId},
      schema: schema,
    })
  }
}

module.service('FinancesCargarMovimientosBancariosHistorialDetallado', FinancesCargarMovimientosBancariosHistorialDetalladoService)



// WEBPACK FOOTER //
// ./src/finanzas/services/CargarMovimientosBancariosHistorialDetalle.js